import I18n from 'I18n';
import ActionButtonComponent from '../ActionButtonComponent';
import { getUsageTrackingChannel } from '../../usage-tracker/trackerChannelIdMapping';
import { usageTracker } from '../../usage-tracker/usageTracker';
import { HideIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const HideButton = ({
  collapsed,
  onClick,
  genericChannelId
}) => {
  const onButtonClick = e => {
    onClick(e);
    usageTracker.track('message-hide', {
      action: 'message hide',
      channel: genericChannelId ? getUsageTrackingChannel(genericChannelId) : undefined
    });
  };
  return /*#__PURE__*/_jsx(ActionButtonComponent, {
    onClick: onButtonClick,
    collapsed: collapsed,
    buttonIcon: HideIcon,
    "data-test-id": 'hide-button',
    i18nButtonText: I18n.text('conversations-inbox-message-history.common-message.hideMessage'),
    tooltipProps: {
      title: I18n.text('conversations-inbox-message-history.common-message.hideMessageDetail'),
      placement: 'right'
    }
  });
};
HideButton.displayName = 'HideButton';
export default HideButton;